import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { tenantLocale, tenantTz } from "./company";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatTimeAgo(iso) {
  if (!iso) return "—";
  const date = new Date(iso);
  const sec = Math.floor((Date.now() - date.getTime()) / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const d = Math.floor(hr / 24);
  return `${d}d ago`;
}

export function formatScheduled(iso) {
  if (!iso) return "Not scheduled";
  const d = new Date(iso);
  return d.toLocaleString(tenantLocale(), { timeZone: tenantTz(),
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
}

export function formatDistance(meters) {
  if (meters == null || isNaN(meters)) return null;
  if (meters < 1000) return `${Math.round(meters)} m`;
  const km = meters / 1000;
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}

export function formatDuration(seconds) {
  if (seconds == null || isNaN(seconds)) return null;
  const m = Math.round(seconds / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${h} h`;
  return `${h} h ${rem} m`;
}
